import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

const testimonials = [
  {
    quote: "Old Monk Tech built our entire platform. We have no idea how it works, but it does, and frankly that's the point.",
    name: 'Kavya R.',
    role: 'Founder · A Startup That Exists',
    initials: 'KR',
    stars: 5,
  },
  {
    quote: "I asked them to make the button blue. They made it blue. Five stars. Would request blue buttons again.",
    name: 'Rohit M.',
    role: 'Button Requester · Various Companies',
    initials: 'RM',
    stars: 5,
  },
  {
    quote: "Their code review found three bugs I introduced on purpose to test them. I haven't told them this. I'm slightly scared.",
    name: 'Priya S.',
    role: 'Senior Engineer · Undisclosed',
    initials: 'PS',
    stars: 5,
  },
  {
    quote: "They said it would take two weeks. It took two weeks. I had budgeted emotionally for six months. Very disorienting.",
    name: 'Anand K.',
    role: 'Product Manager · Realistic Expectations Inc.',
    initials: 'AK',
    stars: 5,
  },
  {
    quote: "I don't understand what they built. My CTO does. He seems pleased. I am pleased that he is pleased. Five stars.",
    name: 'Some CEO',
    role: 'Chief Executive · Company With A CTO',
    initials: 'SC',
    stars: 5,
  },
  {
    quote: "Terrible. They kept showing up on time, delivering what was agreed, and not making up excuses. Completely threw off my schedule.",
    name: 'A Client',
    role: 'Recovering Pessimist · Former Skeptic LLC',
    initials: 'AC',
    stars: 1,
  },
];

export default function Testimonials() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials__inner">
        <div className="testimonials__header">
          <span className="section-label">Social Proof</span>
          <h2 className="testimonials__title">
            In their own<br /><em>words.</em>
          </h2>
        </div>

        <div ref={ref} className={`testimonials__grid fade-hidden ${visible ? 'fade-visible' : ''}`}
          style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial">
              <span className="testimonial__mark">"</span>
              <div className="testimonial__stars">
                {Array.from({ length: 5 }).map((_, j) => (
                  <span key={j} className="testimonial__star"
                    style={{ color: j < t.stars ? undefined : 'var(--text-faint)' }}>
                    {j < t.stars ? '★' : '☆'}
                  </span>
                ))}
              </div>
              <p className="testimonial__quote">{t.quote}</p>
              <div className="testimonial__divider" />
              <div className="testimonial__author">
                <div className="testimonial__avatar">{t.initials}</div>
                <div>
                  <div className="testimonial__name">{t.name}</div>
                  <div className="testimonial__role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
